// Funciones de vehículos: documentos, revisiones, mantenimientos y kilometrajes.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db } from "@/firebase";
import { query, collection, where, getDocs, limit, orderBy } from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import _ from "lodash";
import { colecciones } from "../constantes";

export const funcionesVehiculos = {
  // OBTENER VEHÍCULOS
  async obtenerVehiculos(idEmpresaSeleccionada, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.registros,
      );
      const vehiculos = registros
        ? registros.filter((item) => item.idEmpresa === idEmpresaSeleccionada)
        : [];
      return vehiculos ? vehiculos : [];
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.vehiculos.registros,
        ),
        where("idEmpresa", "==", idEmpresaSeleccionada),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      const registros = await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          return doc.data().placa ? doc.data() : null;
        }),
      );
      const vehiculos = registros.filter((item) => item !== null);
      return vehiculos ? vehiculos : null;
    }
  },
  // OBTENER DOCUMENTOS DE VEHICULOS
  // DOCUMENTOS
  async obtenerDocumentosVehiculos(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.vehiculos.documentos.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // REVISIONES
  async obtenerRevisionesVehiculos(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.vehiculos.revisiones.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER KILOMETRAJES DE VEHICULOS
  async obtenerKilometrajesVehiculos() {
    const vehiculos = await localforage.getItem(
      colecciones.localforage.seguridadVial.vehiculos.registros,
    );
    if (vehiculos) {
      const registros = await Promise.all(
        vehiculos.map(async (vehiculo) => {
          return await this.obtenerUltimoKilometrajeVehiculo(vehiculo.id);
        }),
      );
      const kilometrajes = registros.filter((item) => item !== null);
      return kilometrajes ? kilometrajes : [];
    } else {
      return [];
    }
  },
  // OBTENER VEHICULO
  async obtenerVehiculo(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.registros,
      );
      const vehiculo = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return vehiculo ? vehiculo : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.vehiculos.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.vehiculos.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.vehiculos.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando vehiculo en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerVehiculo, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.vehiculos.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // OBTENER DOCUMENTO DEL VEHICULO
  async obtenerDocumentoVehiculo(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.documentos.registros,
      );
      const documento = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return documento ? documento : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.vehiculos.documentos.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.vehiculos.documentos.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.vehiculos.documentos.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando documento en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerDocumentoVehiculo, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.vehiculos.documentos.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // REVISAR SI SE PUEDE ELIMINAR ESTA FUNCION
  async obtenerRegistroVehiculo(id) {
    const q = query(
      collection(db, "riskmann_seguridadvial_vehiculos"),
      where("id", "==", id),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  // REVISAR SI SE PUEDE ELIMINAR ESTA FUNCION
  async obtenerDocumento(id) {
    const q = query(
      collection(db, "riskmann_seguridadvial_vehiculos_documentos"),
      where("id", "==", id),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  // OBTENER REVISION DEL VEHICULO
  async obtenerRevisionVehiculo(id, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.revisiones.registros,
      );
      const revision = registros
        ? registros.find((item) => item.id === id)
        : null;
      return revision ? revision : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.vehiculos.revisiones.registros,
        ),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER LOS DOCUMENTOS MÁS RECIENTES DEL VEHICULO
  async obtenerUltimoDocumentoVehiculo(idVehiculo, tipo, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.documentos.registros,
      );
      const documentos = Array.isArray(registros)
        ? registros
          .filter(
            (item) => item && item.idVehiculo === idVehiculo && item.tipo === tipo,
          )
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(documentos, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.vehiculos.documentos.registros,
          ),
          where("idVehiculo", "==", idVehiculo),
          where("tipo", "==", tipo),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.vehiculos.documentos.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.vehiculos.documentos.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultimo documento en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimoDocumentoVehiculo, usando local:", e);
        return await this.obtenerUltimoDocumentoVehiculo(idVehiculo, tipo, true);
      }
    }
  },
  async obtenerUltimaRevisionVehiculo(idVehiculo, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.revisiones.registros,
      );
      const revisiones = Array.isArray(registros)
        ? registros
          .filter((item) => item && item.idVehiculo === idVehiculo)
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(revisiones, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.vehiculos.revisiones.registros,
          ),
          where("idVehiculo", "==", idVehiculo),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("fecha", "desc"),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.vehiculos.revisiones.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.vehiculos.revisiones.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultima revision en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimaRevisionVehiculo, usando local:", e);
        return await this.obtenerUltimaRevisionVehiculo(idVehiculo, true);
      }
    }
  },
  async obtenerUltimoMantenimientoVehiculo(idVehiculo) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.vehiculos.mantenimientos.registros,
      ),
      where("idVehiculo", "==", idVehiculo),
      where("registro.estado", "in", ["Creado", "Editado"]),
      orderBy("fecha", "desc"),
      orderBy("registro.creacion", "desc"),
      limit(1),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  async obtenerUltimoKilometrajeVehiculo(idVehiculo, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.kilometrajes
          .registros,
      );
      let kilometraje = Array.isArray(registros)
        ? registros.find((item) => item && item.id === idVehiculo)
        : null;
      if (!kilometraje) {
        // Fallback al vehículo en caché si no hay inspección previa
        const vehiculo = await this.obtenerVehiculo(idVehiculo, true);
        if (vehiculo && vehiculo.kilometraje) {
          const km = typeof vehiculo.kilometraje === "object" ? Number(vehiculo.kilometraje.registro || 0) : Number(vehiculo.kilometraje || 0);
          kilometraje = {
            id: idVehiculo,
            kilometraje: km,
            registro: "-"
          };
        }
      }
      return kilometraje || null;
    } else {
      try {
        const coleccion = collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.registros,
        );
        const filtros = [
          where("vehiculo.id", "==", idVehiculo),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
        ];
        // Se toma la última inspección que tiene kilometraje: la cargada desde papel sin él queda en 0
        let docs = (await getDocs(query(coleccion, ...filtros, limit(1)))).docs;
        if (docs.length > 0 && !(Number(docs[0].data().vehiculo.kilometraje) > 0)) {
          docs = (await getDocs(query(coleccion, ...filtros, limit(20)))).docs;
        }
        const ultima = docs.find((item) => Number(item.data().vehiculo.kilometraje) > 0);
        const result = ultima
          ? {
            id: ultima.data().vehiculo.id,
            kilometraje: ultima.data().vehiculo.kilometraje,
            registro: moment(
              ultima
                .data({ serverTimestamps: "estimate" })
                .registro.creacion.toDate(),
            ).format("YYYY-MM-DD HH:mm:ss"),
          }
          : null;
        if (result) {
          localforage.getItem(colecciones.localforage.seguridadVial.vehiculos.kilometrajes.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== result.id);
            filtrados.push(result);
            localforage.setItem(colecciones.localforage.seguridadVial.vehiculos.kilometrajes.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando kilometraje en local:", e));
        }
        return result;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimoKilometrajeVehiculo, usando local:", e);
        return await this.obtenerUltimoKilometrajeVehiculo(idVehiculo, true);
      }
    }
  },
};
